import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ThunkExtra } from '@shared/store';

import { UPLOADS_SLICE_NAME } from './uploadsSliceName';
import { uploadFileWithProgress } from './xhrUpload';
import { UploadFileThunkArg } from './uploadFileThunkArg';
import { UploadFileResult } from './uploadFileResult';
import type { UploadsState } from './uploadsState';

export const uploadFile = createAsyncThunk<
  UploadFileResult,
  UploadFileThunkArg,
  {
    rejectValue: string;
    state: { uploads: UploadsState };
    extra: ThunkExtra;
  }
>(
  `${UPLOADS_SLICE_NAME}/uploadFile`,
  async ({ id, file, document, variables, filePath }, { dispatch, rejectWithValue, extra, getState, requestId }) => {
    // Binary retry data belongs to this store's ephemeral dependencies, never Redux/persist state.
    extra.uploadFiles.set(id, file);
    try {
      const result = await uploadFileWithProgress({ file, document, variables, filePath }, (progress) => {
        dispatch({ type: `${UPLOADS_SLICE_NAME}/setProgress`, payload: { id, requestId, progress } });
      });
      if (getState().uploads.items[id]?.requestId === requestId) extra.uploadFiles.delete(id);
      return result;
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  }
);
